export enum dashboardModel {
  SINGULAR = 'Dashboard',
  PLURAL = 'Dashboard',
  ROUTE = '/',
  ICON = 'mdi-home-outline',
  ITEM_KEY = 'dashboard'
}
